export default __webpack_public_path__ + "hnry-logo.f881e0bc.png";